import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOcelContext } from '../../stores/OcelContext';

const FileSwitchLoadingOverlay = () => {
  const { t } = useTranslation('common');
  const { isMetadataLoading } = useOcelContext() || {};

  if (!isMetadataLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 min-w-[260px]">
        <svg
          className="w-10 h-10 animate-spin text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
        <div className="text-center">
          <p className="text-base font-semibold text-gray-900">{t('overlay.loadingDataset')}</p>
          <p className="text-sm text-gray-500 mt-1">{t('overlay.loadingDatasetHint')}</p>
        </div>
      </div>
    </div>
  );
};

export default FileSwitchLoadingOverlay;
